import React, { useRef } from 'react';

import { DOMLayer } from './components/DOMLayer';
import { InteractionLayer } from './context/InteractionLayer';

export interface DOMLayerCanvasProps {
  /**
   * context
   */
  context?: {
    disableScrollForHover?: boolean; // view is minmized
    disableScrollForSelect?: boolean; // view is minmized
  };
  /**
   * props of the doms being selected anywhere in the app
   */
  selectedNode?: string;

  /**
   * props of the doms being selected anywhere in the app
   */
  hoveredNode?: string;

  /**
   * callbacks on whenever one node get clicked to receive the injected content
   */
  onClickNode?: (nodeId: string) => void;

  /**
   * callbacks on whenever one node get selected to receive the injected content
   */
  onSelectNode?: (nodeId: string) => void;

  /**
   * callbacks on whenever one or many doms get selected inside this lib
   */
  onHoverNode?: (nodeId?: string) => void;

  /**
   * callbacks on whenever the target icon is clicked to confirm the placement
   */
  onConfirmPlacement?: () => void;

  /**
   * element the panel resides in, we ignore mouse moves here
   */
  panelElement?: HTMLElement;

  /**
   * Override node, defaults to document.body
   */
  node?: HTMLElement;

  /**
   * Override document, defaults to window.document
   */
  document?: Document;
}

export const DOMLayerCanvas = React.memo((props: DOMLayerCanvasProps) => {
  const domLayerCanvasRef = useRef<HTMLDivElement>(null);

  return (
    <div data-cy="dom-layer-canvas" ref={domLayerCanvasRef}>
      <InteractionLayer {...props} domLayerCanvasRef={domLayerCanvasRef}>
        <DOMLayer node={props.node || document.body} document={props.document || window.document} />
      </InteractionLayer>
    </div>
  );
});
